import { render, staticRenderFns } from "./list_subcategories_marketplace_page.vue?vue&type=template&id=80ae033c&scoped=true"
import script from "./list_subcategories_marketplace_page.vue?vue&type=script&lang=js"
export * from "./list_subcategories_marketplace_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ae033c",
  null
  
)

export default component.exports